import { Styles } from '@/components'
import useAuth from '@/hooks/useAuth'
import { LOCAL_STORAGE_AUTH_TOKEN } from '@/services/api/auth/constants'
import sessions from '@/services/api/sessions'
import React, { useCallback, useEffect, useState } from 'react'

function AuthContainer({ children }) {
  const [loading, setLoading] = useState(true)
  const auth = useAuth()

  const fetchUser = useCallback(async () => {
    try {
      const token = localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN)
      if (token && !auth?.user) {
        const { data } = await sessions.currentUser()
        auth.signIn({ user: data, token })
      }
    } finally {
      setLoading(false)
    }
  }, [auth])

  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  if (loading) {
    return (
      <div className="full-vh d-flex flex-centered">
        <Styles.Loading className="loading-lg" />
      </div>
    )
  }

  return children
}

export default AuthContainer
